import { type ActionItem, toastStore } from 'shared/ui'
import { logger } from 'shared/lib'
import { ChatbotConversationStatus, type ChatbotAnalyticListItem } from 'entities/Chatbot'
import { ChatbotConversationApi } from 'entities/Chatbot/api/conversation'

export const unEnrollActions = (
  item: ChatbotAnalyticListItem,
  onSuccess: () => void
): ActionItem[] => {
  const { origin } = item

  if (!('status' in origin) || origin.status !== ChatbotConversationStatus.InProgress) {
    return []
  }

  return [
    {
      key: 'unenroll',
      text: 'Unenroll contact',
      icon: 'block',
      onAction: async () => {
        try {
          await ChatbotConversationApi.unenrollContact({
            conversations: [
              {
                id: origin.core_conversation_id,
                initiator_id: origin.workflow_execution_id,
                initiator_type: 'workflow_execution',
              },
            ],
          })
          toastStore.add({
            type: 'success',
            title: 'Contact unenrolled',
          })
          onSuccess()
        } catch (e) {
          logger.error(e)
          toastStore.add({
            type: 'error',
            title: 'Something went wrong. Please try again',
          })
        }
      },
    },
  ]
}
